import { Link } from '@backstage/core-components';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import AppsIcon from '@material-ui/icons/Apps';
import CodeIcon from '@material-ui/icons/Code';
import GavelIcon from '@material-ui/icons/Gavel';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';

const ENLACES = [
  {
    titulo: 'Dominios',
    destino: '/catalog?filters[kind]=domain',
    icono: <AccountTreeIcon fontSize="small" />,
  },
  {
    titulo: 'Sistemas',
    destino: '/catalog?filters[kind]=system',
    icono: <AppsIcon fontSize="small" />,
  },
  {
    titulo: 'APIs',
    destino: '/api-docs',
    icono: <CodeIcon fontSize="small" />,
  },
  {
    titulo: 'Decisiones',
    destino: '/decisiones',
    icono: <GavelIcon fontSize="small" />,
  },
  {
    titulo: 'Tech Radar',
    destino: '/tech-radar',
    icono: <TrackChangesIcon fontSize="small" />,
  },
  {
    titulo: 'Guía de arquitectura',
    destino: '/docs/default/component/backstage-devcore',
    icono: <MenuBookIcon fontSize="small" />,
  },
  {
    titulo: 'Crear componente',
    destino: '/create',
    icono: <AddCircleOutlineIcon fontSize="small" />,
  },
  {
    titulo: 'Registrar existente',
    destino: '/catalog-import',
    icono: <PlaylistAddIcon fontSize="small" />,
  },
];

const useStyles = makeStyles(theme => ({
  enlace: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

export function QuickLinksWidgetContent() {
  const classes = useStyles();

  return (
    <Grid container spacing={1}>
      {ENLACES.map(enlace => (
        <Grid item xs={12} sm={6} key={enlace.destino}>
          <Link to={enlace.destino} className={classes.enlace}>
            {enlace.icono}
            <Typography variant="body2" component="span">
              {enlace.titulo}
            </Typography>
          </Link>
        </Grid>
      ))}
    </Grid>
  );
}

export const quickLinksWidget = HomePageWidgetBlueprint.make({
  name: 'quick-links',
  params: {
    name: 'quick-links',
    title: 'Accesos rápidos',
    components: async () => ({ Content: QuickLinksWidgetContent }),
  },
});
